import { AxiomaW1AlarmCode } from '../enums/AxiomaW1AlarmCode'

export const MISCELLANEOUS_W1_ALARM_CODES = [
  AxiomaW1AlarmCode.NO_CONSUMPTION,
  AxiomaW1AlarmCode.REVERSE_FLOW,
  AxiomaW1AlarmCode.OVERFLOW,
  AxiomaW1AlarmCode.DAMAGE_TO_METER_HOUSING,
  AxiomaW1AlarmCode.COMMUNICATION_TEMPORARILY_BLOCKED,
  AxiomaW1AlarmCode.HARDWARE_FAILURE_DETECTED,
  AxiomaW1AlarmCode.SOFTWARE_FAILURE_DETECTED,
  AxiomaW1AlarmCode.CALCULATOR_HARDWARE_FAILURE
]
